import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
export const FooterCopyright = ({ href, by, year, className }) => {
    return (_jsx(_Fragment, { children: _jsxs("span", { className: classNames('text-sm text-gray-500 dark:text-gray-400 sm:text-center', className), children: ["\u00A9 ", year, href ? (_jsx("a", { href: href, className: "ml-1 hover:underline", children: by })) : (_jsx("span", { className: "ml-1", children: by })), ". All Rights Reserved."] }) }));
};
